import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=7cc70e5a&scoped=true&lang=pug&"
import script from "./AppView.vue?vue&type=script&lang=ts&"
export * from "./AppView.vue?vue&type=script&lang=ts&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=7cc70e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc70e5a",
  null
  
)

export default component.exports